import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import { Button, ButtonGroup, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// -
import DownloadTypesSelect from "site-apps/assets/components/DownloadTypesSelect";
import WasteTypesSelect from "site-apps/assets/components/WasteTypesSelect";
import SearchSelect from "components/selects/SearchSelect";
import AuthContext from "context/AuthContext";
import { useContext } from "react";

const FormFiltersModel = {
    uid: "",
    uuid: "",
    waste_type: "",
    download_type: "",
    group: "",
    groups_devices: "",
    zone: "",
    route: "",
    island: "",
};

const ContainerFilters = ({
    filters,
    // counter,
    // setCounter,
    params,
    applyFilters,
    isLoading,
}) => {
    const { t: _Tt } = useTranslation("tags");
    // -
    const labelStyle = { width: "100%", fontWeight: "bold", textAlign: "center" };
    const [formFilters, setFormFilters] = useState({ ...FormFiltersModel });
    const onChangeSelect = (e) => {
        const { name, value } = e.target;
        setFormFilters({ ...formFilters, [name]: value });
        if (value) {
            filters.current.chosen[name] = value;
        } else {
            delete filters.current.chosen[name];
        }
    };

    const handleClearFilters = () => {
        filters.current.clear();
        setFormFilters({ ...FormFiltersModel });
    };

    const handleInputChange = (e) => {
        let { name, value } = e.target;
        value = value.trim().toUpperCase();
        setFormFilters({ ...formFilters, [name]: value });
        filters.current.chosen[name] = value;
        if (value) {
            filters.current.chosen[name] = value;
        } else {
            delete filters.current.chosen[name];
        }
    };

    return (
        <Collapse in={true}>
            <div id="filter-collapse">
                <div className="row">
                    <Button variant="link" type="button" onClick={handleClearFilters} style={{ color: "black" }} className="col-1">
                        <FontAwesomeIcon icon="filter-circle-xmark" />
                    </Button>

                    <div className="col" style={{ maxWidth: "200px" }}>
                        <label style={labelStyle}>{_Tt("common.group_device")}</label>
                        <SearchSelect
                            options={[
                                { value: "", label: _Tt("common.all") },
                                ...params.groups_devices.map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                })),
                            ]}
                            placeholder={_Tt("common.all")}
                            isClearable={true}
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    groups_devices: option ? option.value : "",
                                });
                                if (option) {
                                    filters.current.chosen.groups_devices = option.value;
                                } else {
                                    delete filters.current.chosen.groups_devices;
                                }
                            }}
                            value={
                                params.groups_devices
                                    .filter((g) => g.id === formFilters.groups_devices)
                                    .map((g) => ({
                                        value: g.id,
                                        label: g.name,
                                    }))[0] || null
                            }
                        />
                    </div>
                    <div className="col mb-3" style={{ maxWidth: "250px" }}>
                        <label style={labelStyle}>UID</label>
                        <input
                            type="text"
                            className="form-control"
                            name="uid"
                            value={formFilters.uid}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col mb-3" style={{ maxWidth: "250px" }}>
                        <label style={labelStyle}>UUID</label>
                        <input
                            type="text"
                            className="form-control"
                            name="uuid"
                            value={formFilters.uuid}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col pt-3 mt-2">
                        <button
                            type="button"
                            onClick={applyFilters}
                            className="btn btn-outline-primary me-3"
                            title="Aplicar"
                            disabled={isLoading}>
                            {isLoading ? (
                                <FontAwesomeIcon icon="circle-notch" className="fa-spin" />
                            ) : (
                                <FontAwesomeIcon icon="magnifying-glass" />
                            )}{" "}
                            {_Tt("common.search")}
                        </button>
                    </div>

                </div>

            </div>
        </Collapse>
    );
};
export default ContainerFilters;
